export default "__VITE_ASSET__LvCKNKbe__"